import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ChatCenterTableViewComponent } from '../../../components/chat-center/chat-center-table-view/chat-center-table-view.component';
import { ChatWindowComponent } from '../../../components/chat-window/chat-window.component';
import { TableView } from '../../../components/ui/filterable-table/tableView';
import { Conversation } from '../../../models/chat/chatModel';
import { ChatService } from '../../../models/chat/chatService';
import { BasePage } from '../../BasePage';

@Component({
  selector: 'app-chat-center',
  templateUrl: './chat-center.component.html',
  styleUrls: ['./chat-center.component.css'],
  standalone: false,
})
export class ChatCenterComponent extends BasePage implements AfterViewInit {
  tableView: TableView;
  options: any = { pollms: 3000 };

  openConversations: string[] = [];

  @ViewChild('chatQueue') chatQueueControl:
    | ChatCenterTableViewComponent
    | undefined;
  constructor(
    private dialog: MatDialog,
    private chat: ChatService,
  ) {
    super();
    this.tableView = new TableView(ChatCenterTableViewComponent);
  }

  ngAfterViewInit() {
    this.chatQueueControl?.setOptions(this.options);
  }

  public clickedButton(evt: any) {
    if (evt.source == 'Join Session') {
      this.openChat(evt.key);
    }
  }

  openChat(conversationId: string) {
    if (!this.openConversations.includes(conversationId)) {
      let dialogConfig = new MatDialogConfig();
      dialogConfig.width = '400px';
      dialogConfig.data = {
        conversationId: conversationId,
        role: 'support',
      };
      dialogConfig.hasBackdrop = false; // this makes it non-modal
      dialogConfig.panelClass = 'custom-dialog-container';

      this.dialog.open(ChatWindowComponent, dialogConfig);
      this.openConversations.push(conversationId);
    }
  }

  handleChatSelected(event: Conversation) {
    if (event?.id) {
      this.openChat(event.id);
    }
  }
}
